/**
 * Runtime Configuration Accessor
 *
 * Provides access to environment-specific configuration injected at runtime.
 * Falls back to build-time environment variables for local development.
 *
 * Usage:
 *   import config from './config';
 *   const apiUrl = config.BACKEND_URL_EN;
 *
 * How it works:
 *   1. In production: Reads from window.APP_CONFIG (generated at container startup)
 *   2. In development: Falls back to process.env (from .env files)
 */

interface AppConfig {
  GTM_ID: string;
  FACEBOOK_PIXEL_ID: string;
  PCA_API_KEY: string;
  BACKEND_URL_FR: string;
  BACKEND_URL_EN: string;
  DOMAIN_EN: string;
  DOMAIN_FR: string;
  STATIC_ASSETS_URL: string;
  ENV: string;
  PUBLIC_URL: string;
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    APP_CONFIG?: AppConfig;
  }
}

/**
 * Application Configuration
 *
 * Priority:
 * 1. Runtime config from window.APP_CONFIG (production/Cloud Run)
 * 2. Build-time environment variables from process.env (local development)
 * 3. Empty string fallback
 */
export const config: AppConfig = {
  GTM_ID: window.APP_CONFIG?.GTM_ID || process.env.REACT_APP_GTM_ID || '',
  FACEBOOK_PIXEL_ID: window.APP_CONFIG?.FACEBOOK_PIXEL_ID || process.env.REACT_APP_FACEBOOK_PIXEL_ID || '',
  PCA_API_KEY: window.APP_CONFIG?.PCA_API_KEY || process.env.REACT_APP_PCA_API_KEY || '',
  BACKEND_URL_FR: window.APP_CONFIG?.BACKEND_URL_FR || process.env.REACT_APP_BACKEND_URL_FR || '',
  BACKEND_URL_EN: window.APP_CONFIG?.BACKEND_URL_EN || process.env.REACT_APP_BACKEND_URL_EN || '',
  DOMAIN_EN: window.APP_CONFIG?.DOMAIN_EN || process.env.REACT_APP_DOMAIN_EN || '',
  DOMAIN_FR: window.APP_CONFIG?.DOMAIN_FR || process.env.REACT_APP_DOMAIN_FR || '',
  STATIC_ASSETS_URL: window.APP_CONFIG?.STATIC_ASSETS_URL || process.env.STATIC_ASSETS_URL || '',
  ENV: window.APP_CONFIG?.ENV || process.env.REACT_APP_ENV || 'development',
  PUBLIC_URL: window.APP_CONFIG?.PUBLIC_URL || process.env.PUBLIC_URL || '/eclaims'
};

export default config;
